import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media, theme } from 'styles';
import Button from '../Button';

const Wrapper = styled.div`
  transition: all 0.3s;
  display: block;
  border-radius: 6px;
  box-shadow: ${theme.boxShadow.small};
  background-color: ${theme.colors.white};
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.navy};
  text-decoration: none;
  margin-bottom: ${theme.sp.max};

  &:hover {
    box-shadow: ${theme.boxShadow.big};
  }

  ${media.laptop`
    margin-bottom: 0;
  `};
`;

const Image = styled.div`
  display: block;
  border-radius: 6px 6px 0px 0px;
  background-size: cover;
  background-position: center top;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  padding-bottom: 300px;
  width: 100%;
  height: 0;
`;

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  ${media.tablet`
    padding: 30px 40px;
    height: 340px;
  `};
`;

const Client = styled.div`
  display: block;
  margin-bottom: ${theme.sp.s};
  font-size: 18px;
  line-height: 23px;
  font-weight: 500;
  color: ${theme.colors.grey};
`;

const Name = styled.div`
  display: block;
  margin-bottom: ${theme.sp.xl};
  font-size: 44px;
  line-height: 40px;
  font-weight: 700;
  color: ${theme.colors.royal};

  ${media.tablet`
    font-size: 54px;
    line-height: 50px;
  `};
`;

const CardButton = styled(Button)`
  align-self: flex-start;
  padding: 0 24px;
  height: 44px;
  font-size: 14px;

  ${media.tablet`
    margin-top: auto;
    padding: 0 30px;
    height: 50px;
    font-size: 16px;
  `};
`;

const propTypes = {
  relatedCaseStudy: PropTypes.arrayOf({}).isRequired,
};

function RelatedCaseStudy({ relatedCaseStudy }) {
  return (
    <Wrapper>
      <Image src={relatedCaseStudy.cardImage.responsiveResolution.src} />
      <DetailWrapper>
        <Client>{relatedCaseStudy.heading}</Client>
        <Name>{relatedCaseStudy.subHeading}</Name>
        <CardButton blue>View Case Study</CardButton>
      </DetailWrapper>
    </Wrapper>
  );
}

RelatedCaseStudy.propTypes = propTypes;

export default RelatedCaseStudy;



// WEBPACK FOOTER //
// ./src/components/shared/RelatedCaseStudies/RelatedCaseStudy.jsx